import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import styles from "../LandingPage.module.scss";

const InfoSection = ({ titulo, imagem, imagemEsquerda = false, className, children }) => {
    const texto = (
        <>
            <h3 className={styles.homeBlockTitle}>{titulo}</h3>
            <div>{children}</div>
        </>
    );
    const foto = <LazyLoadImage alt="Foto" effect="opacity" src={imagem} className="lazy-image" />;

    return (
        <div className={`${imagemEsquerda ? styles.homeRightInfo : styles.homeLeftInfo} ${className}`}>
            <div className={styles.homeLeftBlock}>{imagemEsquerda ? foto : texto}</div>
            <div className={styles.homeRightBlock}>{imagemEsquerda ? texto : foto}</div>
        </div>
    );
};

export default InfoSection;
